import vizzleAxios from './service';

export default {
  checkPdfLink: async (pdfLinkKey: string) => {
    const url = `${import.meta.env.VITE_APP_MEDIA_API_URL}/media/link/s3?prefix=${pdfLinkKey}`;
    const result = await vizzleAxios.get(url);
    return result;
  },
};
